export default __webpack_public_path__ + "static/the-differance-is-clear-portrait-en_converted-cfa067811ba75c60b6d483eb1111eb81.mp4";